import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import axios from 'axios';

import SvgMeeting from '../components/svg/SvgMeeting';
import { IconClick, IconMoodSmile } from '@tabler/icons-react';

function Career() {
    const [careerData, setCareerData] = useState([]);

    useEffect(() => {
        const getCareerData = async () => {
            try {
                const response = await axios.get("https://admin.maviada.co/api/kariyer");
                setCareerData(response.data.data);
            } catch (error) {
                console.error("API isteği başarısız:", error);
            }
        };

        getCareerData();
    }, []);

    return (
        <div className='hero page-wrapper'>
            <section className='hero'>
                <Container>
                    <Row className="justify-content-center">
                        <Col md={7} lg={6}>
                            <h4 className='mb-3 text-uppercase breadcrumb-text'>ANASAYFA / KARİYER -</h4>
                            <h2 className='mb-3 text-uppercase'>KARİYER</h2>
                            <p className='d-flex'>
                                İş ilanlarımıza aşağıdan göz atabilirsin. Belki de aradığımız kişi sensindir.
                                <span className='d-flex align-items-center ms-2'>
                  <IconMoodSmile size={20} />
                </span>
                            </p>
                        </Col>

                        <Col md={5} lg={4}>
                            <div className='mb-4 pb-2'>
                                <SvgMeeting />
                            </div>
                        </Col>

                        <Col md={10}>
                            <Accordion>
                                {careerData.map((careerItem, index) => (
                                    <Accordion.Item eventKey={index.toString()} key={index}>
                                        <Accordion.Header>{careerItem.title}</Accordion.Header>
                                        <Accordion.Body>
                                            <div className='blue-wrapper' dangerouslySetInnerHTML={{ __html: careerItem.content }}></div>
                                            <div className='pt-2'>
                                                <a
                                                    href={`mailto:${careerItem.email}`}
                                                    className='link-color mt-4 me-2'
                                                >
                                                    {careerItem.email}
                                                </a>
                                                <IconClick className='w-auto' />
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default Career;
